module.exports = __webpack_public_path__ + "static/img/manual-17.0b6832c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-17.png
// module id = vboq
// module chunks = 4